import get from "lodash/get"

export const selectScrollPosition = state => get(state, "scrollPosition")
export const selectIdentifiers = state => get(state, "identifiers", [])
export const selectClonedJourneyHash = state => get(state, "clonedJourneyHash")
export const selectShowRulesPanel = state => state?.showRulesPanel
